import { render } from "./AboutZetraPage.vue?vue&type=template&id=3bfcb2b6&scoped=true"
import script from "./AboutZetraPage.vue?vue&type=script&lang=js"
export * from "./AboutZetraPage.vue?vue&type=script&lang=js"

import "./AboutZetraPage.vue?vue&type=style&index=0&id=3bfcb2b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfcb2b6"]])

export default __exports__